import { Expose } from "class-transformer";

export class IndicatorAlertSettingsDto {
    @Expose({ name: "enable_in_app" })
    enableInApp!: boolean;

    @Expose({ name: "enable_email" })
    enableEmail!: boolean;

    @Expose({ name: "alert_due_7d" })
    alertDue7d!: boolean;

    @Expose({ name: "alert_due_1d" })
    alertDue1d!: boolean;

    @Expose({ name: "alert_due_today" })
    alertDueToday!: boolean;

    @Expose({ name: "alert_overdue" })
    alertOverdue!: boolean;
}
